module.exports = __webpack_public_path__ + "aa3a902eee817ca42402c49c5c0c99cd.svg";